import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import { createPinia } from 'pinia'
// 添加重置样式
import 'normalize.css'
// 添加公共样式
import '@/assets/styles/common.less'

const pinia = createPinia()

createApp(App).use(pinia).use(router).mount('#app')
